<div class="login-box animate__animated animate__fadeIn animate__faster">
    <div class="login-logo"><img src="assets/gpp-logo.png"></div>
    <div class="card">
        <div class="card-body login-card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label>Contraseña</label>
                    <input class="form-control" formControlName="password" type="password">
                </div>
                <div class="form-group">
                    <label>Confirmar contraseña</label>
                    <input class="form-control" formControlName="confirmPassword" type="password">
                </div>
                <br>
                <button type="submit" class="btn btn-login btn-block">Activar cuenta</button>
            </form>
        </div>
    </div>
</div>